import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';

export default function InputModal(props) {
  const { t, dir } = useTranslation();
  const { title, children, onConfirm, onClose, loading, shouldConfirm } = props;

  return (
    <Modal dir={dir}>
      <div
        className={`confirmation-modal input-modal ${
          loading ? 'is-loading' : ''
        }`}
      >
        <button
          data-testid="confirmation-modal-closeButton"
          className="confirmation-modal__close-button"
          onClick={onClose}
        >
          <i className="confirmation-modal__icon assignments-icon icon--cancel" />
        </button>
        <h1 className="confirmation-modal__title">{title}</h1>
        {children}
        <div className="confirmation-modal__buttons">
          {shouldConfirm && (
            <button
              data-testid="confirmation-modal-closeButton"
              className="confirmation-modal__button confirmation-modal__button--cancel"
              onClick={onClose}
            >
              {t('Close')}
            </button>
          )}
          {!shouldConfirm && (
            <>
              <button
                data-testid="confirmation-modal-cancelButton"
                className="confirmation-modal__button confirmation-modal__button--cancel"
                onClick={onClose}
              >
                {t('Cancel')}
              </button>
              <button
                data-testid="confirmation-modal-confirmButton"
                className="confirmation-modal__button confirmation-modal__button--confirm"
                onClick={() => {
                  if (!loading) {
                    onConfirm();
                  }
                }}
              >
                {loading ? (
                  <span
                    data-testid="confirmation-modal-spinner"
                    className="confirmation-modal__spinner"
                  />
                ) : (
                  t('Save')
                )}
              </button>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
}

InputModal.defaultProps = {
  shouldConfirm: false,
};

InputModal.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  shouldConfirm: PropTypes.bool,
};
